import { Turbo } from '@hotwired/turbo-rails'
import { StreamActions } from '@hotwired/turbo'

Turbo.session.drive = false

StreamActions.redirect = function () {
  console.log(this)
  const url = this.getAttribute('url')
  if (!url) return

  window.location.href = url
}

StreamActions.close_modal = function () {
  const target = this.getAttribute('target')
  if (!target) return

  const modal = document.getElementById(target)
  modal?.dispatchEvent(new CustomEvent('ui-modal:close', { bubbles: true }))
}

export const turbo = Turbo
